module.exports = __webpack_public_path__ + "static/media/social.f19b78c9.jpg";